import { Injectable } from "@angular/core";
import { DimmerConverterService } from "@app/shared/services/converter/dimmer-converter.service";
import { TemperatureConverterService } from "@app/shared/services/converter/temperature-converter.service";

@Injectable({
    providedIn: "root",
})
export class DataConverterService {
    constructor(private dimmerConverterService: DimmerConverterService, private temperatureConverterService: TemperatureConverterService) {}

    /**
     * Convert a value to its output value
     *
     * @param currentValue The value to convert
     * @param conversionKey The conversion key used to find the converter service
     * @param units The input and output units
     * @param units.input
     * @param checkAgainstDefaultInput Whether to check against the default input unit
     * @param units.output
     */
    getOutputValue(currentValue: any, conversionKey: string, units: { input: string; output: string }, checkAgainstDefaultInput = false) {
        let convertedValue = currentValue;
        const className = this.getConverter(conversionKey, units);

        if (className) {
            convertedValue = className.getOutputValue(currentValue, units, checkAgainstDefaultInput);
        }

        return convertedValue;
    }

    /**
     * Convert a value to its input value
     *
     * @param currentValue The value to convert
     * @param conversionKey The conversion key used to find the converter service
     * @param units The input and output units
     * @param units.input
     * @param checkAgainstDefaultInput Whether to check against the default input unit
     * @param units.output
     */
    getInputValue(currentValue: any, conversionKey: string, units: { input: string; output: string }, checkAgainstDefaultInput = false) {
        let convertedValue = currentValue;
        const className = this.getConverter(conversionKey, units);

        if (className) {
            convertedValue = className.getInputValue(currentValue, units, checkAgainstDefaultInput);
        }

        return convertedValue;
    }

    getConverter(key, units?) {
        let converter;
        if (key === "dimmer") {
            converter = this.dimmerConverterService;
        } else if (key === "temperature") {
            converter = this.temperatureConverterService;
        }

        // if there are units and a converter class
        if (
            units &&
            converter &&
            // if all the units are the same, we don't need a converter
            converter.defaultUnits.output === units.output &&
            converter.defaultUnits.input === units.input &&
            units.input === units.output
        ) {
            converter = null;
        }

        return converter;
    }
}
